import React from "react";
import {
  detailSmall,
  heading50,
  detailMedium,
  heading200,
  heading150,
} from "../../stitches/combinedStyles";
import { styled } from "../../stitches/stitches.config";

interface IconProps {
  icon: JSX.Element;
  title: string;
  description: string;
}

interface IconSectionProps {
  icons: IconProps[];
}

const IconsSections = ({ icons }: IconSectionProps) => {
  return (
    <IconsContainer className="iconsContainer">
      {icons.map((icon) => (
        <IconBlock
          icon={icon.icon}
          title={icon.title}
          description={icon.description}
          key={icon.title}
        />
      ))}
    </IconsContainer>
  );
};

export default IconsSections;

const IconsContainer = styled("div", {
  margin: "auto",
  maxWidth: 1100,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-around",
  "@sm": {
    paddingTop: 16,
    paddingBottom: 16,
  },
  "@md": {
    paddingTop: 16,
    paddingBottom: 32,
  },
  "@lg": {
    paddingTop: 75,
    paddingBottom: 75,
  },
});

const IconBlock = ({ icon, title, description }: IconProps) => (
  <IconBlockWrapper>
    <IconBlockContainer>
      <IconImageContainer>{icon}</IconImageContainer>
      <IconTitle>{title}</IconTitle>
      <IconDescription>{description}</IconDescription>
    </IconBlockContainer>
  </IconBlockWrapper>
);

const IconBlockWrapper = styled("div", {
  display: "flex",
  padding: 16,
  justifyContent: "center",
  flexBasis: "100%",
  "@sm": { flexBasis: "50%" },
  "@lg": { flexBasis: "25%" },
});

const IconBlockContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  width: "100%",
  maxWidth: 260,
  justifyContent: "space-around",
  alignItems: "center",
  gap: 4,
  "@sm": {
    gap: 16,
  },
});

const IconImageContainer = styled("div", {
  svg: {
    width: 64,
    height: 64,
  },
  "@lg": {
    svg: {
      width: 80,
      height: 80,
    },
  },
});

const IconTitle = styled("h4", {
  ...heading50,
  margin: 0,
  "@sm": {
    maxWidth: 160,
  },
  "@md": {
    maxWidth: 240,
    ...heading150,
  },
});

const IconDescription = styled("p", {
  ...detailSmall,
  color: "$black55",
  marginTop: 4,
  marginBottom: 0,
  "@md": {
    ...detailMedium,
    color: "$black55",
  },
});
